import React from "react";
import { generatePath, useLocation, useNavigate, useParams } from "react-router-dom";
import { INDIVIDUAL_SESSION_REPORT, INDIVIDUAL_START_SESSION, SCHOOL_CLIENT_LIST } from "config/paths";
import ManageGoals from "../../components/ManageGoals";
import { ErrorBoundary } from "react-error-boundary";

const ClientIndividualGoals = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { previousUrl } = state || {};

  const { assessmentId, clientId, clientType } = useParams();

  const submitCallback = async (response) => {
    try {
      if (!response?.error) {
        navigate(
          generatePath(INDIVIDUAL_START_SESSION, {
            assessmentId,
            clientId,
            clientType
          })
        );
      }
    } catch (err) {
      console.log("Error submitting step", err);
    }
  };

  const handleClickBack = () => {
    navigate(
      generatePath(SCHOOL_CLIENT_LIST, {
        assessmentId,
        clientId,
        clientType
      })
    );
  }

  return (
    <ErrorBoundary fallback={"Something went wrong, please try reloading the page."}>
      <ManageGoals
        onSubmit={submitCallback}
        onNavigateBack={handleClickBack}
        clientType={clientType}
        previousUrl={previousUrl}
      />
    </ErrorBoundary>
  );
};

export default ClientIndividualGoals;
